module.exports = __webpack_public_path__ + "img/qr_code_official_accounts.80203bfc.png";